module.exports = __webpack_public_path__ + "static/media/SK_Cover@2x.5db4af8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/SEEK/SK_Cover@2x.jpg
// module id = 196
// module chunks = 0